import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '디지털 시대에 기업은 온라인을 통해 고객을 유치할 뿐만 아니라 실제 위치에서 효과적으로 상호작용하고자 합니다. 지오펜싱(Geofencing), 즉 가상 지리적 울타리는 고객이 특정 지리적 영역에 들어오거나 나가거나 이동할 때 즉시 메시지나 혜택을 보낼 수 있게 해주는 기술입니다. 이 글에서는 지오펜싱이 무엇인지, 어떻게 작동하는지, 그리고 기업에 어떤 실질적인 이점을 제공하는지 설명하겠습니다.',
  keywords: 'Geofencing, 지오펜싱 기술, 리테일 지오펜싱, RTLS, 실시간 위치 추적',
  ogSite: '지오펜싱 (Geofencing)이란 무엇이며, 기업에 어떤 이점을 제공하는가?',
  title: '지오펜싱 (Geofencing)이란 무엇이며, 기업에 어떤 이점을 제공하는가?',
  ogUrl: 'https://orbro.io/blog/what-is-geofencing?',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_EuhZ0PoooTscFCMKqotYOBJrV3uavkqv2no8u_u5LUCv7_hcd8D-6XxfqrKgI7x2wPgJ71YKTUaGQqNmDRcJijy7JtKo3m-qs0ol-T_qpH9glQ3uwDEFQHECSLDfCpXCTJcMLGQo2mgB7yk1KuTstprBF5IvWVggGB131POsA_lV59O77YN8pEljo9Cg_Foc2MyGjax-fmseh2NBpA_8AL2C4TJCepkyn0GtEXAGzTnx8FaIYDob-xrtJzT3-NooXH_qZrEeQRYl3qChMKu9EvA_5MNf2_5lo3kG2WmAlvsbAZjugRAcZkg0TUnOkyfk2941ExH--7BkMBzqRSqrjK_O_Il-sU8JMXgg6A7IGig8gjApXjyTvkpP6b-U2H3aTcabO7F3JfmDBr_Zum1pzOnakxd-zVfpmh3ahOyCfMouxdoaAT0zdJDlK84NErxy1fGiVG4E3PQ5jM-BcMQMS_a_IT7fVzrCAVwoZv_U2OvDsG9nO2Bdq0EO-9Dd_ew1NuDbh17mFqGzU3Kss8J9WdT6CZSiYMwOW0RexlncrljIf1mmXa2E1AWYs-zD_nyhp-31us1jv9g5RW3kPIt6gtPGloVj6fuG5rOJVtlGgMwkWp0wBnwiCVTCFv0iHXH1CH9JexXLH6vhi-f6DSikVDfUoCWo9VAigc9w-XM4NoXxLiYiSsCgQwqCY9CUQyfvsLCZ-Q8I3pYBl1tEfxXzHXDf3tUjVD-ejcWEfNBUn5mdcOhoH4cDzwd0hwfTqmfJLhByCAYzylMQC67RPcolpthGTz-l2-82HS-jPxT-EDlWPeXKXph9mVtde_i21iyKpsd7vVmEzi_EDkMjQWHRtx8EZYZDOHOl88W7KP4gkmIUZOiWK82vxWiIyLZN6LjQ7mVxpTp2Yv0Ubw_bBuIgG5zjpY745I9fw4O2wPN5bF2CpMHO_NwAcYyfhoNS37mZuFLt9fU2AGuBiPgqRnHNGIJrGK_EGbUZMK9CLYBFzX5DzLk4l_SZ8CabwukTQi7n2ukHRAQBqZn-SmOp_fqHAZaYdJvPNZp2IfLljceH_3n5q51Lt2Rna0QInhkcXrnezD56AGSOFHRoia7mH89b3Ol88oCqfHW5fg8gS56srUrg3HJkRhFwxKdND2ZvRKEUnxhtRMw_BMf84iRiu-V7xvCJobO3WvSGeb_mGvHKCn_51aY66jEymRHIGy_yn4gKLH6y1fFzs-r6x0hq6SBHvTztC_VtSMAEIadXUHrJ2n4WcBd3XME0gideozPU4YayidooXd1VOrj90CjACawwpyhzV3lIctdSTxa1u7ssgex_HWdBXrFicbedGal83VMZ7b-VMVMt9uMLxagd05g2L1vL-6fe1ayxJ606WMGOtNF-3Eu0nGUiRzU8oNGhbilyN8Dx2xKIB2AhWFzFLknabetOp_rJWsKiGJfSQLXA29EnU8DUem0LlSFkaJ1JEeTz7OFgZRCYbdSz85QhBKTWjb2SkjlCyiHXPTfPhAZmi_IxrRJFlALK3mdIY61OATcm_6YiKX4_ffVPraSidSj286YrnMf9u8TGzwP6QhWYMFfIyVmaAWw_WwE-eORtYuwXAf2M4Yc0o4TPMRp01vO_xLxQYJHIJOoExjf6bZFw=w1418-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-27',
  tag1: '#지오펜싱',
  tag2: '#지오펜싱기술',
  tag3: '#리테일지오펜싱',
  tag4: '#RTLS #실시간위치추적',
  text: [
    {
      head: '',
      subHead: '',
      desc: '디지털 시대에 기업은 온라인을 통해 고객을 유치할 뿐만 아니라 실제 위치에서 효과적으로 상호작용하고자 합니다. 지오펜싱(Geofencing), 즉 가상 지리적 울타리는 고객이 특정 지리적 영역에 들어오거나 나가거나 이동할 때 즉시 메시지나 혜택을 보낼 수 있게 해주는 기술입니다. 이 글에서는 지오펜싱이 무엇인지, 어떻게 작동하는지, 그리고 기업에 어떤 실질적인 이점을 제공하는지 설명하겠습니다.',
      dot: ''
    },
    {
      head: '1. 지오펜싱이 (Geofencing)란?',
      subHead: '',
      desc: '지오펜싱은 GPS, Wi-Fi, Bluetooth 또는 기타 위치 기술을 사용해 특정 영역을 정의하거나 제한하고, 지리적 지역(상점, 공항, 도시 지역) 주변에 가상 “울타리”를 설정하는 기술입니다. 사용자의 모바일 기기가 앱이나 위치 추적 권한을 가지고 있을 때, 시스템은 해당 영역에 “들어오거나”, “나가거나”, “이동하는” 이벤트를 감지하고 행동(알림, 쿠폰 발송, 데이터 수집)을 트리거합니다.',
      dot: ''
    },
    {
      head: '2. 지오펜싱 (Geofencing)의 작동 원리',
      subHead: '',
      desc: '지리적 영역 정의: 중심 좌표와 반경(예: 100-500m)을 설정합니다.\n\n이벤트 등록: 기업의 모바일 앱이 기기의 위치 접근 권한을 부여합니다.\n\n지속적인 모니터링: SDK 또는 백그라운드 서비스가 기기의 좌표를 추적합니다.\n\n행동 트리거: 기기가 조건(울타리 안/밖/통과)을 충족하면 시스템이 푸시 알림, 이메일 또는 마케팅 캠페인을 트리거합니다.',
      dot: ''
    },
    {
      head: '3. 기업을 위한 지오펜싱 (Geofencing)의 이점',
      subHead: '',
      desc: '상호작용 및 전환 증대\n즉각적인 맞춤형 혜택: 고객이 상점 반경에 들어오면 쿠폰이나 프로모션을 즉시 보내 구매를 유도합니다.\n서비스 제안: 레스토랑은 손님이 주변 지역에 들어오면 메뉴나 음료 혜택을 보낼 수 있습니다.\n\n마케팅 효율성 향상\n광고 비용 절감: 대량 광고 대신 상점을 방문할 가능성이 있는 고객에게만 타겟팅합니다.\n실제 행동 측정: 고객이 울타리 영역을 얼마나 자주 지나가는지, 머무는 시간, 전환율을 추적합니다.\n\n고객 경험 개선\n위치 안내: 앱이 자동으로 결제 카운터, 프로모션 구역 또는 주차장으로 안내합니다.\n안전 알림: 산업 단지에서 작업자가 위험 지역으로 이동하면 경고를 보냅니다.\n\n운영 및 물류 최적화\n차량 관리: 자동으로 창고 출입 위치를 기록하고, 지연 시 경고합니다.\n자산 모니터링: 장비나 기계를 지정된 영역에서 반출/반입하는 것을 제어합니다.',
      dot: ''
    },
    {
      head: '4. 지오펜싱 (Geofencing)실제 응용 사례',
      subHead: '',
      desc: '소매: 고객이 상점 근처에 오면 20% 할인 코드를 보냅니다.\n\n배송: 운송업체는 차량이 주소 근처에 도착하면 “10분 내 배송” 알림을 활성화합니다.\n\n호텔 - 여행: 고객이 게이트에 도착하면 자동으로 환영하고, 앱을 통해 빠른 체크인을 제공합니다.\n\n이벤트 - 전시회: 참관객이 전시장에 들어오면 디지털 지도와 부스 정보를 제공합니다.',
      dot: ''
    },
    {
      head: '5. 지오펜싱 (Geofencing) 구현 시 유의사항',
      subHead: '',
      desc: '개인정보 보호: 사용자의 허가를 받고 위치 데이터를 보호합니다.\n\n적절한 반경 선택: 너무 넓으면 개인화가 떨어지고, 너무 좁으면 놓칠 수 있습니다.\n\n배터리 및 데이터 최적화: 백그라운드 모니터링은 정확성과 에너지 소비의 균형을 맞춰야 합니다.\n\n적시 콘텐츠 업데이트: 혜택은 상황에 맞고 유효해야 합니다.',
      dot: ''
    },
    {
      head: '6. 결론',
      subHead: '',
      desc: '지오펜싱은 기업이 고객과 스마트하고, 개인화된, 비용 효율적인 방식으로 접근하고 상호작용할 수 있게 해주는 강력한 도구입니다. 소매, 물류, 이벤트 조직 등 누구나 지오펜싱을 활용해 사용자 경험을 향상시키고 운영을 최적화할 수 있습니다. 망설이지 마세요 – 지금 바로 자신만의 지리적 “울타리”를 구축해 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
